const global = window

// Remplissage automatique
inputs.behavior.confirm = function (data, name, niceName, type, input, parent, inputWindow) {
    if (data.confirm) {
        input.data('hold', true)
        input.click(function(e) {
            if (!input.data('hold')) {
                setTimeout(function() {
                    input.data('hold', true)
                }, 100)
            } else {
                Swal.fire({
                title: data.confirm.title,
                icon: data.confirm.icon, // dans SweetAlert2 c’est "icon" et non "type"
                text: data.confirm.text,
                html: data.confirm.html,
                showCancelButton: true,
                confirmButtonColor: '#d1202f',
                cancelButtonColor: '#686868',
                confirmButtonText: 'Oui',
                cancelButtonText: 'Non',
                }).then((result) => {
                if (result.isConfirmed) {
                    input.removeData('hold');
                    input.get(0).click();
                }
                });

                e.preventDefault();
                e.stopPropagation();
            }
        })
    }
    return data
}
